import { thousandSeparated } from 'shared/util/formatting';
import { ResultDataStats } from '@/domain';

type NumResultsProps = {
    stats: ResultDataStats;
    className?: string;
    hideText?: boolean;
};

export const NumResults = (props: NumResultsProps) => (
    <div className={`font-bold ${props.className ?? ''}`} data-testid="numberOfResults">
        {props.stats?.numResults ? thousandSeparated(props.stats.numResults) : '0'}
        {props.hideText ? '' : ' treff'}
    </div>
);
